const BASE_URL = (process.env.NODE_ENV !== "production" ? "http://localhost:8080" : "https://api.datagekko.com");
const BASE_API = "/api";
const BASE_API_URL = BASE_URL + BASE_API;
const BASE_AVATAR_URL = "https://storage.googleapis.com/devgekko-test/avatar/";

const BASE_DATA_URL = "http://localhost:8100/d/";

const PROD = (process.env.NODE_ENV === "production");
const LOG_LEVEL = PROD ? 'error' : 'debug';

export { BASE_URL, BASE_AVATAR_URL, BASE_API_URL, BASE_DATA_URL, PROD, LOG_LEVEL };



// WEBPACK FOOTER //
// ./src/services/ConfigService.jsx